import { configUtils } from '@tunein/web-utils';
import config from './constants/config';

export default configUtils.getMapConfigResponse(config);
